const keyCodes = Object.freeze({
    'TAB': 9,
    'RETURN': 13,
    'ESC': 27,
    'SPACE': 32,
    'PAGEUP': 33,
    'PAGEDOWN': 34,
    'END': 35,
    'HOME': 36,
    'LEFT': 37,
    'UP': 38,
    'RIGHT': 39,
    'DOWN': 40
});

function handleSidebarLink(e) {
    let openMenu = true;
    let setFocus = false;

    const $sidebarSlider = $('.sidebar-slider');
    const $sidebarClose = $('.sidebar-close');
    const $link = $(this);
    const $sidebarMenu = $link.parents('.sidebar-menu');
    const $sidebarMenuLinks = $sidebarMenu.find('a');
    let linkIndex = 0;

    $sidebarMenuLinks.each(function(i){
        if ($link.attr('href') === $(this).attr('href')) {
            linkIndex = i;
        }
    });

    if (e.type === 'keydown') {
        let runHandler = true;
        setFocus = true;
        switch (e.keyCode) {
            case keyCodes.DOWN:
                if (linkIndex === ($sidebarMenuLinks.length - 1)) {
                    $sidebarClose.focus();
                } else {
                    $sidebarMenu.find(`a:eq(${linkIndex + 1})`).focus();
                }
                openMenu = false;
                break;
            case keyCodes.UP:
                if (linkIndex === 0) {
                    $sidebarClose.focus();
                } else {
                    $sidebarMenu.find(`a:eq(${linkIndex - 1})`).focus();
                }
                openMenu = false;
                break;
            case keyCodes.TAB:
                runHandler = false;
                if (linkIndex === 0) {
                    if (e.shiftKey) {
                        $sidebarClose.focus();
                        runHandler = true;
                    }
                }
                if (linkIndex === ($sidebarMenuLinks.length - 1)) {
                    if (!e.shiftKey) {
                        $sidebarClose.focus();
                        runHandler = true;
                    }
                }
                openMenu = false;
                break;
            case keyCodes.RETURN:
            case keyCodes.SPACE:
                openMenu = true;
                break;
            case keyCodes.RIGHT:
                openMenu = !$(this).hasClass('sidebar-menu-back');
                break;
            case keyCodes.LEFT:
                openMenu = $(this).hasClass('sidebar-menu-back');
                break;
            default:
                return;
        }
        if (runHandler) {
            e.stopPropagation();
            e.preventDefault();
        }
    } else {
        if (e.originalEvent.detail === 0) {
            setFocus = true;
        }
    }


    if (openMenu) {
        if ($(this).attr('data-target')) {
            e.stopPropagation();
            e.preventDefault();
            const target_menu = $(this).data('target');

            if (target_menu) {
                $sidebarMenu.removeClass('sidebar-menu-open');
                $(target_menu).addClass('sidebar-menu-open');

                if ($(this).parents('.sidebar-slide').hasClass('level-1')) {
                    $sidebarSlider.removeClass('sidebar-menu-level-1').addClass('sidebar-menu-level-2');
                } else {
                    $sidebarSlider.removeClass('sidebar-menu-level-2').addClass('sidebar-menu-level-1');
                }

                if (setFocus) {
                    setTimeout(() => {
                        $(target_menu).find('a:eq(0)').focus();
                    }, 300);
                }

            }
        }
    }

}

function closeSidebarMenu() {
    const $html = $('html');
    const $sidebar = $('.sidebar');
    const $sidebarMenu = $('.sidebar-menu');
    const $sidebarSlider = $('.sidebar-slider');

    setTimeout(() => {
        $sidebarMenu.removeClass('sidebar-menu-open');
        $('#sidebar-main-menu').addClass('sidebar-menu-open');
        $sidebarSlider.removeClass('sidebar-menu-level-2').addClass('sidebar-menu-level-1');
        $('.header-menu-toggle').focus();
    }, 300);

    $sidebar.attr('aria-hidden', 'true');
    $sidebar.find("[tabindex]").attr('tabindex', '-1');
    $html.removeClass('sidebar-open');
}

function openSidebarMenu(focusFirstLink = true) {
    const $html = $('html');
    const $sidebar = $('.sidebar');

    $sidebar.attr('aria-hidden', 'false');
    $sidebar.find("[tabindex]").attr('tabindex', '0');
    $html.addClass('sidebar-open');
    if (focusFirstLink) {
        setTimeout(() => {
            $('.sidebar-slider:eq(0)').find('a:eq(0)').focus();
        }, 300);
    }
}

function handleMenuToggle(e) {
    const $html = $('html');
    let runHandler = true;
    let focusFirstLink = false;

    if (e.type === 'keydown') {
        runHandler = false;
        if (e.keyCode === keyCodes.SPACE || e.keyCode === keyCodes.RETURN) {
            runHandler = true;
            focusFirstLink = true;
        }
    }

    if (runHandler) {
        e.stopPropagation();
        e.preventDefault();
        if ($html.hasClass('sidebar-open')) {
            closeSidebarMenu();
        } else {
            openSidebarMenu(focusFirstLink);
        }
    }
}

export function initSidebarMenu() {
    const $sidebarMenu = $('.sidebar-menu');

    $('.header-menu-toggle, .sidebar-overlay, .sidebar-close').on('click', handleMenuToggle);
    $('.header-menu-toggle, .sidebar-close').on('keydown', handleMenuToggle);

    $sidebarMenu.find('a').on('click', handleSidebarLink);
    $sidebarMenu.find('a').on('keydown', handleSidebarLink);
}

